import React, { Component } from "react";
import { COLORLIST, TEXT_COLORLIST, PATHS } from "../../../Constants";
import DateUtils from "../../../Utils/DateUtils";
import moment from "moment";
import CommonUtils from "../../../Utils/CommonUtils";
import {
  APIResponse,
  OperationStatus,
  PLATFORM,
} from "../../../Communication/Constants";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Strings } from "../../../Resources/Strings/i18n";
import Refresh from "../../../Resources/Images/ic_refresh.png";
import "./NewUserCard.scss";
import { Row, Col, Container, Alert } from "reactstrap";
import RecentActivity from "../../../Resources/Images/ic_last_activity.png";
import WakeupClock from "../../../Resources/Images/ic_wakeup.png";
import Button from "@material-ui/core/Button";
import ic_view from "../../../Resources/Images/ic_view.png";
import Calories from "../../../Resources/Images/ic_active_calories.png";
import ic_dashboard_heart_rate from "../../../Resources/Images/ic_dashboard_heart_rate.png";
import ic_dashboard_blood_pressure from "../../../Resources/Images/ic_dashboard_blood_pressure.png";
import ic_alerts from "../../../Resources/Images/ic_alerts.png";
import ic_dashboard_sleep_time from "../../../Resources/Images/ic_dashboard_sleep_time.png";
import ic_dashboard_body_temperature from "../../../Resources/Images/ic_dashboard_body_temperature.png";
import ic_dashboard_pulse_ox from "../../../Resources/Images/ic_dashboard_pulse_ox.png";
import ic_dashboard_respiration_rate from "../../../Resources/Images/ic_dashboard_respiration_rate.png";
import FootSteps from "../../../Resources/Images/ic_steps.png";
import { Modal1 } from "../../CustomModal/Modal1";
import DashboardAction from "../DashboardAction";
import ic_gps from "../../../Resources/Images/ic_gps.png";
import Distance from "../../../Resources/Images/ic_distance.png";
import { collection, limit, onSnapshot, orderBy, query, where } from "firebase/firestore";
import db from "../../../Utils/FirebaseUtils";

class NewUserCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formattedFirstActivityText: "-",
      formattedFirstActivityTextUnit: "",
      formattedUpdatedAtTimeText: "",
      formattedRecentActivityTextUnit: "",
      formattedUpdatedAtDateText: "",
      selectedDate: "",
      startDate: "",
      showLovedOneCard: false,
      locationData: undefined,
      latitude: 0,
      longitude: 0,
    };
    this.DashboardAction = new DashboardAction();
    this.initLoadLovedOneCard = false;
  }

  componentDidMount() {
    const date =
      this.state.selectedDate !== ""
        ? this.state.selectedDate
        : DateUtils.getCurrentDate("M/D/YYYY");
    this.initLoadLovedOneCard = true;
    this.getSummeryByDate(date);

    this.getRenderedSummeryData();
    // Commenting code below temporarily as we dont need 4g watch data from firebase.
    /* if (this.props && this.props.userList && this.props.userList.monitored_users) {
      // console.log(this.props)
      this.props.userList.monitored_users.map((user) => {
        if(user && user.id === this.props.id && user.watch && user.watch.extra_information && user.watch.extra_information.watch_type === '4G'){
          let smart_watch_imei_number = user.watch.extra_information.smart_watch_imei_number;
          this.getDataFromSmartWatch(smart_watch_imei_number);
        }
        else {
          // console.log('No 4G Watch Found for this user: ', this.props.first_name + ' ' + this.props.last_name);
        }
      })
    } */
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userSummery !== this.props.userSummery) {
      this.getRenderedSummeryData();
    }
  }

  //below function gets called for checking null/ updating values
  getRenderedSummeryData = () => {
    let userActivityInfo = this.props.userSummery;
    let formattedFirstActivityText = "-",
      formattedFirstActivityTextUnit = "",
      formattedRecentActivityText = "-",
      formattedRecentActivityTextUnit = "",
      formattedScreenTimeText = "-",
      footsteps = 0,
      distance = 0,
      calories = 0,
      firstUsage = "",
      recentUsage = "";
    let latitude = 0;
    let longitude = 0;
    var heartRate = 0;
    var totalSleepMinutes = 0;
    var sleepHours = 0;
    var sleepMinutes = 0;
    var bloodPressure = "";
    var bloodPressureUnit = "";
    let oxygenLevel = "";
    let respiratoryRate = "";
    let respiratoryRateUnit = "";
    let bodyTemperature = "";
    let bodyTemperatureUnit = "";
    let footstepsTimestamp = "";
    let caloriesTimestamp = "";
    let distanceTimestamp = "";
    let heartRateTimestamp = "";
    let bloodPressureTimestamp = "";
    let oxygenLevelTimestamp = "";
    let respiratoryRateTimestamp = "";
    let bodyTemperatureTimestamp = "";
    if (userActivityInfo.info) {
      if (userActivityInfo.info.sleep_data) {
        var sleepInfoArray = userActivityInfo.info.sleep_data.sleep_info;
        if (sleepInfoArray && sleepInfoArray.length > 0) {
          sleepInfoArray.map((sleepInfo) => {
            var timeDiffInMinutes = DateUtils.getDifferenceBetweenDates(
              sleepInfo.sleep_start_time,
              sleepInfo.sleep_end_time,
              "yyyy-MM-DD hh:mm:ss Z",
              "minutes"
            );
            totalSleepMinutes = totalSleepMinutes + timeDiffInMinutes;
          });
        }
      }

      if (totalSleepMinutes > 0) {
        sleepHours = Math.floor(totalSleepMinutes / 60);
        sleepMinutes = totalSleepMinutes % 60;
      }
      if (userActivityInfo.info.first_phone_usage) {
        let timestamp = undefined;
        timestamp = moment(
          userActivityInfo.info.first_phone_usage,
          "YYYY-MM-DD hh:mm:ss a"
        ).unix();
        if (timestamp == undefined) {
          timestamp = moment(
            userActivityInfo.info.first_phone_usage,
            "YYYY-MM-DD hh:mm:ss"
          ).unix();
        }

        let newDate = new Date(timestamp * 1000);
        formattedFirstActivityText = DateUtils.convertDateFormat(
          newDate,
          "yyyy-MM-dd HH:mm:ss",
          "hh:mm"
        );
        formattedFirstActivityTextUnit = DateUtils.convertDateFormat(
          newDate,
          "yyyy-MM-dd HH:mm:ss",
          "a"
        );
      }

      if (userActivityInfo.info.recent_phone_usage) {
        let timestamp = undefined;
        timestamp = moment(
          userActivityInfo.info.recent_phone_usage,
          "YYYY-MM-DD hh:mm:ss a"
        ).unix();
        if (timestamp == undefined) {
          timestamp = moment(
            userActivityInfo.info.recent_phone_usage,
            "YYYY-MM-DD hh:mm:ss"
          ).unix();
        }

        let recentUsage = new Date(timestamp * 1000);
        formattedRecentActivityText = DateUtils.convertDateFormat(
          recentUsage,
          "yyyy-MM-dd HH:mm:ss",
          "hh:mm"
        );
        formattedRecentActivityTextUnit = DateUtils.convertDateFormat(
          recentUsage,
          "yyyy-MM-dd HH:mm:ss",
          "a"
        );

        this.setState({
          formattedRecentActivityText,
          formattedRecentActivityTextUnit,
        });

        recentUsage = userActivityInfo.info.recent_phone_usage;

        this.setState({
          formattedUpdatedAtDateText: DateUtils.convertDateFormat(
            recentUsage,
            "yyyy-MM-DD",
            "MMM DD, YYYY ddd"
          ),
          formattedUpdatedAtTimeText: formattedRecentActivityText,
        });
      }

      if (
        userActivityInfo.info.heart_rate_day &&
        userActivityInfo.info.heart_rate_day.value
      ) {
        heartRate = userActivityInfo.info.heart_rate_day.value;
        heartRateTimestamp = DateUtils.convertDateFormatToLocalTimezone(
          userActivityInfo.info.heart_rate_day.recorded_timestamp,
          "hh:mma ddd MMM DD"
          );
      }
      if (
        userActivityInfo.info.footsteps &&
        userActivityInfo.info.footsteps.total
      ) {
        footsteps = userActivityInfo.info.footsteps.total;
        footstepsTimestamp = DateUtils.convertDateFormatToLocalTimezone(
          userActivityInfo.info.footsteps.recorded_timestamp,
          "hh:mma ddd MMM DD"
          );
      }
      if (
        userActivityInfo.info.calories_consumed &&
        userActivityInfo.info.calories_consumed.total
      ) {
        calories = userActivityInfo.info.calories_consumed.total;
        caloriesTimestamp = DateUtils.convertDateFormatToLocalTimezone(
          userActivityInfo.info.calories_consumed.recorded_timestamp,
          "hh:mma ddd MMM DD"
          );
      }
      if (
        userActivityInfo.info.distance_covered &&
        userActivityInfo.info.distance_covered.total
      ) {
        distance = userActivityInfo.info.distance_covered.total;
        distanceTimestamp = DateUtils.convertDateFormatToLocalTimezone(
          userActivityInfo.info.distance_covered.recorded_timestamp,
          "hh:mma ddd MMM DD"
          );
      }
      if (
        userActivityInfo.info.screen_interaction_time &&
        userActivityInfo.info.screen_interaction_time.total
      ) {
        if (
          CommonUtils.convertMS(
            userActivityInfo.info.screen_interaction_time.total
          )
        ) {
          formattedScreenTimeText = CommonUtils.convertMS(
            userActivityInfo.info.screen_interaction_time.total
          );
        }
      }
      if (
        userActivityInfo.info.blood_pressure &&
        userActivityInfo.info.blood_pressure.value &&
        userActivityInfo.info.blood_pressure.value.systolic_bp &&
        userActivityInfo.info.blood_pressure.value.diastolic_bp
      ) {
        bloodPressure =
          userActivityInfo.info.blood_pressure.value.systolic_bp +
          " / " +
          userActivityInfo.info.blood_pressure.value.diastolic_bp;
        bloodPressureUnit =
          userActivityInfo.info.blood_pressure.source &&
          (userActivityInfo.info.blood_pressure.source ==
            PLATFORM.ANDROID_MANUAL ||
            userActivityInfo.info.blood_pressure.source == PLATFORM.IOS_MANUAL)
            ? Strings("BloodPressureUnitManual")
            : Strings("BloodPressureUnitAutomatic");
        bloodPressureTimestamp = DateUtils.convertDateFormatToLocalTimezone(
          userActivityInfo.info.blood_pressure.recorded_timestamp,
          "hh:mma ddd MMM DD"
          );
      } else {
        bloodPressure = "";
        bloodPressureUnit = "";
      }
      if (
        userActivityInfo.info.location &&
        userActivityInfo.info.location.latitude &&
        userActivityInfo.info.location.longitude
      ) {
        latitude = userActivityInfo.info.location.latitude;
        longitude = userActivityInfo.info.location.longitude;
        this.DashboardAction.getLocation(
          { latitude: latitude, longitude: longitude, language: "en" },
          (actionCallback) => {
            if (actionCallback.status === OperationStatus.SUCCESS) {
              let addressLoc = "";
              let locationAt = "";
              actionCallback.data.data.results.map((address) => {
                if (address.address_components.length == 3) {
                  addressLoc = address.address_components[0].long_name;
                  // ", " +
                  // address.address_components[2].long_name;
                  locationAt = DateUtils.convertDateFormat(
                    userActivityInfo.info.location.recorded_timestamp,
                    "yyyy-MM-dd HH:mm:ss Z",
                    "hh:mm a"
                  );
                }
              });
              this.setState({
                address: addressLoc,
                locationData: locationAt,
              });
            } else {
              this.setState({
                address: undefined,
                locationData: undefined,
              });
            }
          }
        );
      } else {
        this.setState({
          latitude: 0,
          longitude: 0,
          address: undefined,
        });
      }
      if (
        userActivityInfo.info.body_temperature &&
        userActivityInfo.info.body_temperature.value
      ) {
        bodyTemperature = userActivityInfo.info.body_temperature.value.toFixed(1);
        bodyTemperatureUnit = "F";
        bodyTemperatureTimestamp = DateUtils.convertDateFormatToLocalTimezone(
          userActivityInfo.info.body_temperature.recorded_timestamp,
          "hh:mma ddd MMM DD"
          );
      }
      if (
        userActivityInfo.info.respiratory_rate &&
        userActivityInfo.info.respiratory_rate.value
      ) {
        respiratoryRate = userActivityInfo.info.respiratory_rate.value;
        respiratoryRateUnit = "bpm";
        respiratoryRateTimestamp = DateUtils.convertDateFormatToLocalTimezone(
          userActivityInfo.info.respiratory_rate.recorded_timestamp,
          "hh:mma ddd MMM DD"
          );
      }
      if (
        userActivityInfo.info.oxygen_level &&
        userActivityInfo.info.oxygen_level.value
      ) {
        oxygenLevel = userActivityInfo.info.oxygen_level.value;
        oxygenLevelTimestamp = DateUtils.convertDateFormatToLocalTimezone(
          userActivityInfo.info.oxygen_level.recorded_timestamp,
          "hh:mma ddd MMM DD"
          );
      }
    }

    this.distanceUnit = Strings("distance_meter");
    if (distance) {
      distance = parseInt(distance);
      let distanceInKms = distance / 1000;
      if (distanceInKms >= 1.0) {
        distance = distanceInKms.toFixed(2);
        this.distanceUnit = Strings("distance_km");
      }
    }

    if (calories) {
      calories = parseFloat(calories).toFixed(0);
    }

    let currentFeelingImg = undefined;
    let currentFeelingText = "-";
    let currentFeeling = undefined;
    if (
      userActivityInfo.info &&
      userActivityInfo.info.emotional_state &&
      userActivityInfo.info.emotional_state.value
    ) {
      currentFeeling = userActivityInfo.info.emotional_state.value;
      currentFeelingImg = CommonUtils.getImageResourceByEmotionId(
        currentFeeling
      );
      currentFeelingText = CommonUtils.getEmotionTextByEmotionId(
        currentFeeling
      );
    }

    let recentActivityDate = DateUtils.convertDateFormat(
      recentUsage,
      "yyyy-MM-DD HH:mm:ss Z",
      "M/D/YYYY"
    );
    let currentDate = DateUtils.getCurrentDate("M/D/YYYY");
    let startDate =
      this.state.startDate === ""
        ? DateUtils.subtractNoOfDaysFromDate(
            currentDate,
            "M/D/YYYY",
            this.props.history_days_available
          )
        : this.state.startDate;
    let updatedAtDate = DateUtils.convertDateFormat(
      userActivityInfo.Date,
      "yyyy-MM-DD HH:mm:ss Z",
      "M/D/YYYY"
    );
    let dateList =
      this.state.dateList === ""
        ? DateUtils.getListOfDatesBetweenDates(
            startDate,
            "M/D/YYYY",
            currentDate,
            "M/D/YYYY",
            "M/D/YYYY"
          )
        : this.state.dateList;
    //last seen or updated at value
    let selectedDate = updatedAtDate;
    //? updatedAtDate // recentActivityDate// userActivityInfo.Date
    //: this.state.selectedDate;
    let datesToShow =
      this.state.datesToShow === ""
        ? dateList.length > 3
          ? dateList.slice(0, dateList.length)
          : dateList
        : this.state.datesToShow;

    this.setState({
      recentActivityDate,
      subscriptionDays: this.props.history_days_available,
      selectedDate,
      footsteps,
      distance,
      calories,
      firstUsage,
      formattedFirstActivityText,
      startDate,
      formattedFirstActivityTextUnit,
      formattedRecentActivityText,
      datesToShow,
      formattedRecentActivityTextUnit,
      formattedScreenTimeText,
      dateList,
      currentFeelingImg,
      currentFeelingText,
      currentFeeling,
      latitude,
      longitude,
      heartRate,
      totalSleepMinutes,
      sleepHours,
      sleepMinutes,
      bloodPressure,
      bloodPressureUnit,
      oxygenLevel,
      respiratoryRate,
      respiratoryRateUnit,
      bodyTemperature,
      bodyTemperatureUnit,
      footstepsTimestamp,
      caloriesTimestamp,
      distanceTimestamp,
      heartRateTimestamp,
      bloodPressureTimestamp,
      oxygenLevelTimestamp,
      respiratoryRateTimestamp,
      bodyTemperatureTimestamp,
    });
  };

  //below function gets called when date is changed
  getSummeryByDate = (sourceDate) => {
    let forDate = DateUtils.convertDateFormat(sourceDate, "", "yyyy-MM-DD");
    let loggedInUserId = this.props.userInfo.id;
    let forUserId = this.props.id;
    let actionFlag = true; // passing true for updating summery on date change
    //PARAM(idFlag, accessToken, userid, forDate, for_userid, actionCallback)
    this.setState({ showModal: true });
    this.DashboardAction.getSummeryData(
      {
        addUserIdInRequest: true,
        accessToken: this.props.userInfo.accessToken,
        loggedInUserId: loggedInUserId,
        forDate: forDate,
        for_userid: forUserId,
        actionFlag: actionFlag,
      },
      (actionCallback) => {
        if (
          actionCallback.error.errorCode &&
          actionCallback.error.errorCode === APIResponse.SUMMARY_NOT_FOUND
        ) {
          if (this.initLoadLovedOneCard) {
            this.setState({
              showModal: false,
            });
          } else {
            this.setState({
              showError: true,
              showModal: false,
              errorMessage: actionCallback.error.errorMessage,
            });
          }
          this.initLoadLovedOneCard = false;
        } else if (
          actionCallback.status === OperationStatus.NETWORK_NOT_REACHABLE
        ) {
          this.setState({
            errorMessage: actionCallback.error.errorMessage,
            showError: true,
            showModal: false,
          });
        } else {
          this.setState({
            showModal: false,
            showError: false,
            selectedDate: sourceDate,
          });
        }
      }
    );
  };

  // method to fetch data from firestore database.
  /* getDataFromSmartWatch =  (smart_watch_imei_number) => {
    // console.log('GetDataFromSmartWatch Called')
    let heartRateFromSmartWatch = "";
    let heartRateTimestampFromSmartWatch = "";
    let bloodPressureFromSmartWatch = "";
    let bloodPressureTimestampFromSmartWatch = "";
    let bloodOxygenFromSmartWatch = "";
    let bloodOxygenTimestampFromSmartWatch = "";
    let bodyTemperatureFromSmartWatch = "";
    let bodyTemperatureTimestampFromSmartWatch = "";
    let dailyStepsFromSmartWatch = "";
    let dailyStepsTimestampFromSmartWatch = "";
    let calculatedDistanceFromFootsteps = 0;

    let currentDate = DateUtils.convertDateFormat(new Date(),"","yyyyMMDD");
    // query to fetch paramteres according to device Id;
    const heartRateQuery = query(collection(db,'heart-rate'), where("device_id", "==", `${smart_watch_imei_number}`), orderBy("datetime", "desc"), limit(1));
    const bloodPressureQuery = query(collection(db,'blood-pressure'), where("device_id", "==", `${smart_watch_imei_number}`), orderBy("datetime", "desc"), limit(1));
    const dailyStepsQuery = query(collection(db,'daily-steps'), where("device_id", "==", `${smart_watch_imei_number}`), where("date", "==", parseInt(currentDate)));
    const bloodOxygenQuery = query(collection(db,'blood-oxygen'), where("device_id", "==", `${smart_watch_imei_number}`), orderBy("datetime", "desc"), limit(1));
    const bodyTemperatureQuery = query(collection(db,'temperature'), where("device_id", "==", `${smart_watch_imei_number}`), orderBy("datetime", "desc"), limit(1));
    
    onSnapshot(heartRateQuery, (querySnapShot) => {
      querySnapShot.docChanges().forEach((change) => {
        if(change.type === "added") {
          // console.log('HeartRate: Newly Added Value -> ', change.doc.data());
          heartRateFromSmartWatch = change.doc.data().value;
          heartRateTimestampFromSmartWatch = DateUtils.convertDateFormat(change.doc.data().datetime, "", "hh:mma ddd MMM DD");
          this.setState({heartRateFromSmartWatch, heartRateTimestampFromSmartWatch});
        }
      });
    },(error) => {
        // console.log('Error Occured in Heart Rate Snapshot', error.name);
    });

    onSnapshot(bloodPressureQuery, (querySnapShot) => {
      querySnapShot.docChanges().forEach((change) => {
        if(change.type === "added") {
          // console.log('BP: Newly added Value: ', change.doc.data());
          const low = change.doc.data().low;
          const high = change.doc.data().high;
          bloodPressureFromSmartWatch = `${high}/${low}`
          bloodPressureTimestampFromSmartWatch = DateUtils.convertDateFormat(change.doc.data().datetime, "", "hh:mma ddd MMM DD");
          this.setState({bloodPressureFromSmartWatch, bloodPressureTimestampFromSmartWatch});
        }
      });
    },(error) => {
      // console.log('Error Occured in Blood Pressure Snapshot', error.name);
    });

    onSnapshot(dailyStepsQuery, (querySnapShot) => {
      querySnapShot.docChanges().forEach((change) => {
        if(change.type === "added") {
          // console.log('Daily Steps: Newly added Value: ', change.doc.data());
          dailyStepsFromSmartWatch = change.doc.data().steps_old;
          dailyStepsTimestampFromSmartWatch = DateUtils.convertDateFormat(change.doc.data().datetime, "", "hh:mma ddd MMM DD");
          //calculate the average distance covered in meters based on footsteps
          if (dailyStepsFromSmartWatch > 0) {
            calculatedDistanceFromFootsteps = ((0.5 * dailyStepsFromSmartWatch) / 1000).toFixed(2);
          }
          this.setState({dailyStepsFromSmartWatch, dailyStepsTimestampFromSmartWatch, calculatedDistanceFromFootsteps});
        }
      });
    },(error) => {
      // console.log('Error Occured in Daily Steps Snapshot');
    });

    onSnapshot(bloodOxygenQuery, (querySnapShot) => {
      querySnapShot.docChanges().forEach((change) => {
        if(change.type === "added") {
          // console.log('SPO2: Newly added Value: ', change.doc.data());
          bloodOxygenFromSmartWatch = change.doc.data().oxygen;
          bloodOxygenTimestampFromSmartWatch = DateUtils.convertDateFormat(change.doc.data().datetime, "", "hh:mma ddd MMM DD");
          this.setState({bloodOxygenFromSmartWatch, bloodOxygenTimestampFromSmartWatch});
        }
      });
    },(error) => {
      // console.log('Error Occured in SPO2 Snapshot');
    });

    onSnapshot(bodyTemperatureQuery, (querySnapShot) => {
      querySnapShot.docChanges().forEach((change) => {
        if(change.type === "added") {
          // console.log('Body Temperature: Newly added Value: ', change.doc.data());
          bodyTemperatureFromSmartWatch = change.doc.data().value;
          bodyTemperatureTimestampFromSmartWatch = DateUtils.convertDateFormat(change.doc.data().datetime, "", "hh:mma ddd MMM DD");
          this.setState({bodyTemperatureFromSmartWatch, bodyTemperatureTimestampFromSmartWatch});
        }
      });
    },(error) => {
      // console.log('Error Occured in Body Temperature Snapshot');
    });

    //todo: Return all the unsubscribe snapshot objects so that we can unsubscribe them if not needed;
  } */

  render() {
    let first_name = this.props.first_name || "";
    let last_name = this.props.last_name || "";
    let relation = this.props.relation || "";

    let full_name =
      (first_name
        ? first_name[0].toUpperCase() + first_name.substring(1)
        : "") +
      " " +
      (last_name ? last_name[0].toUpperCase() + last_name.substring(1) : "");

    return (
      <div className="NewUserCard">
        {this.state.showModal && !this.initLoadLovedOneCard ? (
          <Modal1
            show={this.state.showModal}
            handleClose={this.hideModal}
            parent={"exitsession"}
          ></Modal1>
        ) : null}
        {this.state.showError ? window.scrollTo(0, 0) : null}
        {this.state.showError ? (
          <Alert color="danger" className="alertMessage">
            {this.state.errorMessage}
          </Alert>
        ) : null}
        <div
          className={
            this.props.inviteTokenInfo &&
            !this.props.inviteTokenInfo.isInvitedUser
              ? "Card"
              : "Card InvitedCard"
          }
        >
          <div className="personInfoContainer">
            <div className="profileImg">
              <div className="initials">
                <label>
                  {first_name && first_name[0].toUpperCase()}
                  {last_name && last_name[0].toUpperCase()}
                </label>
              </div>
            </div>
            <div className="infoContainer">
              <div className="profileName">{full_name}</div>
              <div className="baseContainer">
                <div className="innerBase">
                  <div className="profileRelation">
                    {relation &&
                      relation[0].toUpperCase() +
                        relation.substring(1).toLowerCase()}
                  </div>
                  <div className="profilePlan">{this.props.plan}</div>
                </div>
                <div
                  className="refreshBtn"
                  onClick={() => {
                    this.initLoadLovedOneCard = false;
                    this.getSummeryByDate(this.state.selectedDate);
                  }}
                >
                  <img src={Refresh} alt="Refresh" />
                </div>
              </div>

              <div className="updatedAt">
                {this.state.formattedUpdatedAtTimeText !== "" ? (
                  <>
                    {Strings("Updated")}
                    {this.state.formattedUpdatedAtTimeText}{" "}
                    {this.state.formattedRecentActivityTextUnit},{" "}
                    {this.state.formattedUpdatedAtDateText.replace(" ", ". ")}
                  </>
                ) : 
                  <>
                    {Strings('Updating...')}
                  </>
                }
              </div>
            </div>
          </div>
          <div className="DataCardContainer">
            <div className="wellnessDataContainer">
              <div className="Data_heading">Wellness Data</div>
              <div className="Data_content">
                <Container className="parent_Container">
                  <Row md={12} className="rowContainer">
                    <Col md={6} className="dataContainer">
                      <div className="base">
                        <div className="statusImg">
                          <img src={WakeupClock} alt="WakeUp time"></img>
                        </div>
                        <div className="summery">
                          <div className="keyText">{Strings("WakeUp")}</div>
                          <div className="valueText">
                            {this.state.formattedFirstActivityText}
                            &nbsp;
                            <span className="smallValueText">
                              {this.state.formattedFirstActivityTextUnit}
                            </span>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col md={6} className="dataContainer">
                      <div className="base">
                        <div className="statusImg">
                          <img
                            src={ic_dashboard_sleep_time}
                            alt="Sleep time"
                          ></img>
                        </div>
                        <div className="summery">
                          <div className="keyText">{Strings("sleepHours")}</div>
                          <div className="valueText">
                            {this.state.totalSleepMinutes !== 0 ? (
                              <>
                                {this.state.sleepHours}
                                <span className="smallValueText">
                                  {Strings("timeHourUnit")}&nbsp;
                                </span>
                                {this.state.sleepMinutes}
                                <span className="smallValueText">
                                  {Strings("timeMinuteUnit")}
                                </span>
                              </>
                            ) : (
                              <>
                                {this.state.sleepMinutes}
                                <span className="smallValueText">
                                  {Strings("timeMinuteUnit")}
                                </span>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>
                <Container className="parent_Container">
                  <Row md={12} className="rowContainer">
                    <Col md={6} className="dataContainer">
                      <div className="base">
                        <div className="statusImg">
                          <img src={Distance} alt="Distance"></img>
                        </div>
                        <div className="summery">
                          <div className="keyText">{Strings("Distance")}</div>
                          <div className="valueText">
                            {this.state.distance === 0 ? (
                              "-"
                            ) : (
                              <>
                                {this.state.distance}
                                &nbsp;
                                <span className="smallValueText">
                                  {this.distanceUnit}
                                </span>
                              </>
                            )}
                          </div>
                          <div className="timestampText">
                            {this.state.distanceTimestamp === 0
                              ? ""
                              : this.state.distanceTimestamp}
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col md={6} className="dataContainer">
                      <div className="base">
                        <div className="statusImg">
                          <img src={FootSteps} alt="Footsteps"></img>
                        </div>
                        <div className="summery">
                          <div className="keyText">{Strings("Steps")}</div>
                          <div className="valueText">
                            {this.state.footsteps === 0
                              ? "-"
                              : this.state.footsteps}
                          </div>
                          <div className="timestampText">
                            {this.state.footstepsTimestamp === 0
                              ? ""
                              : this.state.footstepsTimestamp}
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>
                <Container className="parent_Container">
                  <Row md={12} className="rowContainer">
                    <Col md={6} className="dataContainer">
                      <div className="base">
                        <div className="statusImg">
                          <img src={Calories} alt="Active Calories"></img>
                        </div>
                        <div className="summery">
                          <div className="keyText">
                            {Strings("ActiveCalories")}
                          </div>
                          <div className="valueText">
                            {this.state.calories === 0
                              ? " -"
                              : this.state.calories}
                          </div>
                          <div className="timestampText">
                            {this.state.caloriesTimestamp === 0
                              ? ""
                              : this.state.caloriesTimestamp}
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col md={6} className="dataContainer">
                      <div className="base">
                        <div className="statusImg">
                          <img src={RecentActivity} alt="Last Activity"></img>
                        </div>
                        <div className="summery">
                          <div className="keyText">
                            {Strings("LastActivity")}
                          </div>
                          <div className="valueText">
                            {this.state.formattedRecentActivityText}
                            &nbsp;
                            <span className="smallValueText">
                              {this.state.formattedRecentActivityTextUnit}
                            </span>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </div>
              <div className="ButtonContainer">
                <div className="ViewButton">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      let selectedLovedOneData = {
                        userSummery: this.props.userSummery,
                        index: this.props.index,
                        id: this.props.id,
                        first_name: this.props.first_name,
                        last_name: this.props.last_name,
                        relation: this.props.relation,
                        deviceType: this.props.deviceType,
                        plan: this.props.plan,
                        chartsStatus: this.props.chartsStatus,
                        history: this.props.history,
                        history_data_display: this.props.history_data_display,
                        history_days_available:
                          this.props.history_days_available,
                        history_data_display_unit:
                          this.props.history_data_display_unit,

                        data_update_interval_minutes:
                          this.props.data_update_interval_minutes,
                      };
                      let savedState = JSON.stringify(selectedLovedOneData);
                      localStorage.setItem("myState", savedState);
                      this.props.history.push(PATHS.HOME + PATHS.LOVED_ONES);
                    }}
                  >
                    <img src={ic_view} alt="ic_view" />
                    <div> {Strings("View")}</div>
                  </Button>
                </div>
                {this.props.inviteTokenInfo &&
                this.props.inviteTokenInfo.isInvitedUser ? null : (
                  <div className="ViewButton">
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        let selectedLovedOneData = {
                          id: this.props.id,
                          first_name: this.props.first_name,
                          last_name: this.props.last_name,
                          relation: this.props.relation,
                        };
                        let savedState = JSON.stringify(selectedLovedOneData);
                        localStorage.setItem("selectedAlertId", savedState);
                        this.props.history.push(PATHS.ALERTS);
                      }}
                    >
                      <img src={ic_alerts} alt="ic_alerts" />
                      <div> {Strings("Alerts")}</div>
                    </Button>
                  </div>
                )}
              </div>
            </div>

            <div className="healthDataContainer">
              <div className="Data_heading">Health Data</div>
              <div className="Data_content">
                <Container className="parent_Container">
                  <Row md={12} className="rowContainer">
                    <Col md={6} className="dataContainer">
                      <div className="base">
                        <div className="statusImg">
                          <img
                            src={ic_dashboard_heart_rate}
                            alt="WakeUp time"
                          ></img>
                        </div>
                        <div className="summery">
                          <div className="keyText">{Strings("HeartRate")}</div>
                          <div className="valueText">
                            {this.state.heartRate === 0
                              ? "-"
                              : this.state.heartRate}
                            &nbsp;
                            <span className="smallValueText">
                              {this.state.heartRate !== 0
                                ? Strings("HeartRateUnit")
                                : null}
                            </span>
                          </div>
                          <div className="timestampText">
                            {this.state.heartRateTimestamp === 0
                              ? ""
                              : this.state.heartRateTimestamp}
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col md={6} className="dataContainer">
                      <div className="base">
                        <div className="statusImg">
                          <img
                            src={ic_dashboard_blood_pressure}
                            alt="Screen time"
                          ></img>
                        </div>
                        <div className="summery">
                          <div className="keyText">
                            {Strings("BloodPressure")}
                          </div>
                          <div className="valueText">
                            {this.state.bloodPressure == ""
                              ? "-"
                              : this.state.bloodPressure}
                            &nbsp;
                            <span className="smallValueText">
                              {this.state.bloodPressure !== ""
                                ? this.state.bloodPressureUnit
                                : null}
                            </span>
                          </div>
                          <div className="timestampText">
                            {this.state.bloodPressureTimestamp === 0
                              ? ""
                              : this.state.bloodPressureTimestamp}
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>
                <Container className="parent_Container">
                  <Row md={12} className="rowContainer">
                    <Col md={6} className="dataContainer">
                      <div className="base">
                        <div className="statusImg">
                          <img
                            src={ic_dashboard_pulse_ox}
                            alt="Oxygen Level"
                          ></img>
                        </div>
                        <div className="summery">
                          <div className="keyText">{Strings("SpO2")}</div>
                          <div className="valueText">
                            {this.state.oxygenLevel === ""
                              ? "-"
                              : this.state.oxygenLevel}
                            &nbsp;
                          </div>
                          <div className="timestampText">
                            {this.state.oxygenLevelTimestamp === 0
                              ? ""
                              : this.state.oxygenLevelTimestamp}
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col md={6} className="dataContainer">
                      <div className="base">
                        <div className="statusImg">
                          <img
                            src={ic_dashboard_respiration_rate}
                            alt="Respiration Rate"
                          ></img>
                        </div>
                        <div className="summery">
                          <div className="keyText">
                            {Strings("respirationRate")}
                          </div>
                          <div className="valueText">
                            {this.state.respiratoryRate === ""
                              ? "-"
                              : this.state.respiratoryRate}
                            &nbsp;
                            <span className="smallValueText">
                              {this.state.respiratoryRate !== ""
                                ? this.state.respiratoryRateUnit
                                : null}
                            </span>
                          </div>
                          <div className="timestampText">
                            {this.state.respiratoryRateTimestamp === 0
                              ? ""
                              : this.state.respiratoryRateTimestamp}
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>
                <Container className="parent_Container">
                  <Row md={12} className="rowContainer">
                    <Col md={6} className="dataContainer">
                      <div className="base">
                        <div className="statusImg">
                          <img
                            src={ic_dashboard_body_temperature}
                            alt="Body Temperature"
                          ></img>
                        </div>
                        <div className="summery">
                          <div className="keyText">
                            {Strings("bodyTemperature")}
                          </div>
                          <div className="valueText">
                            {this.state.bodyTemperature === ""
                              ? "-"
                              : this.state.bodyTemperature}
                            &nbsp;
                            <span className="smallValueText">
                              {this.state.bodyTemperature !== ""
                                ? this.state.bodyTemperatureUnit
                                : null}
                            </span>
                          </div>
                          <div className="timestampText">
                            {this.state.bodyTemperatureTimestamp === 0
                              ? ""
                              : this.state.bodyTemperatureTimestamp}
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </div>
              <div className="ButtonContainer">
                <div className="ViewButton">
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    onClick={() => {
                      let selectedLovedOneData = {
                        userSummery: this.props.userSummery,
                        index: this.props.index,
                        id: this.props.id,
                        first_name: this.props.first_name,
                        last_name: this.props.last_name,
                        relation: this.props.relation,
                        deviceType: this.props.deviceType,
                        plan: this.props.plan,
                        chartsStatus: this.props.chartsStatus,
                        history: this.props.history,
                        history_data_display: this.props.history_data_display,
                        history_days_available:
                          this.props.history_days_available,
                        history_data_display_unit:
                          this.props.history_data_display_unit,

                        data_update_interval_minutes:
                          this.props.data_update_interval_minutes,
                      };
                      let savedState = JSON.stringify(selectedLovedOneData);
                      localStorage.setItem("myState", savedState);
                      this.props.history.push(PATHS.HOME + PATHS.LOVED_ONES);
                    }}
                  >
                    <img src={ic_view} alt="ic_view" />
                    <div> {Strings("View")}</div>
                  </Button>
                </div>
              </div>
            </div>

            <div className="dailyDataContainer">
              <div className="Data_heading">Daily Data</div>
              <div className="Data_subheading">Feeling</div>
              <div className="Data_content">
                <div className="parent_Container">
                  <div
                    className={
                      this.state.currentFeeling === 1
                        ? "sadEmotionSection"
                        : "emotionSection"
                    }
                  >
                    <img
                      src={CommonUtils.getImageResourceByEmotionId(1)}
                      alt={"sad"}
                    />
                    <div className="emotionText">
                      {CommonUtils.getEmotionTextByEmotionId(1)}
                    </div>
                  </div>
                  <div
                    className={
                      this.state.currentFeeling === 2
                        ? "downEmotionSection"
                        : "emotionSection"
                    }
                  >
                    <img
                      src={CommonUtils.getImageResourceByEmotionId(2)}
                      alt={"sad"}
                    />
                    <div className="emotionText">
                      {CommonUtils.getEmotionTextByEmotionId(2)}
                    </div>
                  </div>

                  <div
                    className={
                      this.state.currentFeeling === 3
                        ? "okEmotionSection"
                        : "emotionSection"
                    }
                  >
                    <img
                      src={CommonUtils.getImageResourceByEmotionId(3)}
                      alt={"sad"}
                    />
                    <div className="emotionText">
                      {CommonUtils.getEmotionTextByEmotionId(3)}
                    </div>
                  </div>

                  <div
                    className={
                      this.state.currentFeeling === 4
                        ? "fineEmotionSection"
                        : "emotionSection"
                    }
                  >
                    <img
                      src={CommonUtils.getImageResourceByEmotionId(4)}
                      alt={"sad"}
                    />
                    <div className="emotionText">
                      {CommonUtils.getEmotionTextByEmotionId(4)}
                    </div>
                  </div>

                  <div
                    className={
                      this.state.currentFeeling === 5
                        ? "happyEmotionSection"
                        : "emotionSection"
                    }
                  >
                    <img
                      src={CommonUtils.getImageResourceByEmotionId(5)}
                      alt={"sad"}
                    />
                    <div className="emotionText">
                      {CommonUtils.getEmotionTextByEmotionId(5)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="watchDataContainer">
              <div className="Data_heading">Watch Data</div>
              <div className="Data_content">
                <Container className="parent_Container">
                  <Row md={12} className="rowContainer">
                    <Col md={6} className="dataContainer">
                      <div className="base">
                        <div className="statusImg">
                          <img
                            src={ic_dashboard_pulse_ox}
                            alt="Oxygen Level"
                          ></img>
                        </div>
                        <div className="summery">
                          <div className="keyText">{Strings("SpO2")}</div>
                          <div className="valueText">
                            {this.state.oxygenLevel === ""
                              ? "-"
                              : this.state.oxygenLevel}
                            &nbsp;
                          </div>
                          <div className="timestampText">
                            { this.state.oxygenLevelTimestamp === 0
                            ? ""
                            : this.state.oxygenLevelTimestamp
                            }
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col md={6} className="dataContainer">
                      <div className="base">
                        <div className="statusImg">
                          <img
                            src={ic_dashboard_respiration_rate}
                            alt="Respiration Rate"
                          ></img>
                        </div>
                        <div className="summery">
                          <div className="keyText">
                            {Strings("respirationRate")}
                          </div>
                          <div className="valueText">
                            {this.state.respiratoryRate === ""
                              ? "-"
                              : this.state.respiratoryRate}
                            &nbsp;
                            <span className="smallValueText">
                              {this.state.respiratoryRate !== ""
                                ? this.state.respiratoryRateUnit
                                : null}
                            </span>
                          </div>
                          <div className="timestampText">
                            { this.state.respiratoryRateTimestamp === 0
                            ? ""
                            : this.state.respiratoryRateTimestamp
                            }
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>
                <Container className="parent_Container">
                  <Row md={12} className="rowContainer">
                    <Col md={6} className="dataContainer">
                      <div className="base">
                        <div className="statusImg">
                          <img
                            src={ic_dashboard_body_temperature}
                            alt="Body Temperature"
                          ></img>
                        </div>
                        <div className="summery">
                          <div className="keyText">
                            {Strings("bodyTemperature")}
                          </div>
                          <div className="valueText">
                            {this.state.bodyTemperature === ""
                              ? "-"
                              : this.state.bodyTemperature}
                            &nbsp;
                            <span className="smallValueText">
                              {this.state.bodyTemperature !== ""
                                ? this.state.bodyTemperatureUnit
                                : null}
                            </span>
                          </div>
                          <div className="timestampText">
                            { this.state.bodyTemperatureTimestamp === 0
                            ? ""
                            : this.state.bodyTemperatureTimestamp
                            }
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>
                <div className="ButtonContainer">
                  <div className="ViewButton">
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      onClick={() => {
                        let selectedLovedOneData = {
                          userSummery: this.props.userSummery,
                          index: this.props.index,
                          id: this.props.id,
                          first_name: this.props.first_name,
                          last_name: this.props.last_name,
                          relation: this.props.relation,
                          deviceType: this.props.deviceType,
                          plan: this.props.plan,
                          chartsStatus: this.props.chartsStatus,
                          history: this.props.history,
                          history_data_display: this.props.history_data_display,
                          history_days_available: this.props.history_days_available,
                          history_data_display_unit: this.props.history_data_display_unit,
                          data_update_interval_minutes: this.props.data_update_interval_minutes,
                        };
                        let savedState = JSON.stringify(selectedLovedOneData);
                        localStorage.setItem("myState", savedState);
                        this.props.history.push(PATHS.HOME + PATHS.LOVED_ONES);
                      }}
                    >
                      <img src={ic_view} alt="ic_view" />
                      <div> {Strings("View")}</div>
                    </Button>
                  </div>
                </div>
              </div>
            </div> */}

            {/* <div className="smartWatchDataContainer">
              <div className="Data_heading">4G Watch Data</div>
              <div className="Data_content">
                <Container className="parent_Container">
                  <Row md={12} className="rowContainer">
                    <Col md={6} className="dataContainer">
                      <div className="base">
                        <div className="statusImg">
                          <img src={Distance} alt="Distance"></img>
                        </div>
                        <div className="summery">
                          <div className="keyText">{Strings("Distance")}</div>
                          <div className="valueText">
                            {this.state.calculatedDistanceFromFootsteps ===
                            0 ? (
                              "-"
                            ) : (
                              <>
                                {this.state.calculatedDistanceFromFootsteps}
                                &nbsp;
                                <span className="smallValueText">
                                  {this.state
                                    .calculatedDistanceFromFootsteps !== "-" &&
                                    Strings("distance_km")}
                                </span>
                              </>
                            )}
                          </div>
                          <div className="timestampText">
                            {this.state.calculatedDistanceFromFootsteps === 0
                              ? ""
                              : this.state.dailyStepsTimestampFromSmartWatch}
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col md={6} className="dataContainer">
                      <div className="base">
                        <div className="statusImg">
                          <img src={FootSteps} alt="Footsteps"></img>
                        </div>
                        <div className="summery">
                          <div className="keyText">{Strings("Steps")}</div>
                          <div className="valueText">
                            {this.state.dailyStepsFromSmartWatch === 0
                              ? "-"
                              : this.state.dailyStepsFromSmartWatch}
                          </div>
                          <div className="timestampText">
                            {this.state.dailyStepsFromSmartWatch === 0
                              ? ""
                              : this.state.dailyStepsTimestampFromSmartWatch}
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>
                <Container className="parent_Container">
                  <Row md={12} className="rowContainer">
                    <Col md={6} className="dataContainer">
                      <div className="base">
                        <div className="statusImg">
                          <img
                            src={ic_dashboard_pulse_ox}
                            alt="Oxygen Level"
                          ></img>
                        </div>
                        <div className="summery">
                          <div className="keyText">{Strings("SpO2")}</div>
                          <div className="valueText">
                            {this.state.bloodOxygenFromSmartWatch === ""
                              ? "-"
                              : this.state.bloodOxygenFromSmartWatch}
                            &nbsp;
                          </div>
                          <div className="timestampText">
                            {this.state.bloodOxygenTimestampFromSmartWatch === 0
                              ? ""
                              : this.state.bloodOxygenTimestampFromSmartWatch}
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col md={6} className="dataContainer">
                      <div className="base">
                        <div className="statusImg">
                          <img
                            src={ic_dashboard_body_temperature}
                            alt="Body Temperature"
                          ></img>
                        </div>
                        <div className="summery">
                          <div className="keyText">
                            {Strings("bodyTemperature")}
                          </div>
                          <div className="valueText">
                            {this.state.bodyTemperatureFromSmartWatch === ""
                              ? "-"
                              : this.state.bodyTemperatureFromSmartWatch}
                            &nbsp;
                          </div>
                          <div className="timestampText">
                            {this.state
                              .bodyTemperatureTimestampFromSmartWatch === 0
                              ? ""
                              : this.state
                                  .bodyTemperatureTimestampFromSmartWatch}
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>
                <Container className="parent_Container">
                  <Row md={12} className="rowContainer">
                    <Col md={6} className="dataContainer">
                      <div className="base">
                        <div className="statusImg">
                          <img
                            src={ic_dashboard_heart_rate}
                            alt="WakeUp time"
                          ></img>
                        </div>
                        <div className="summery">
                          <div className="keyText">{Strings("HeartRate")}</div>
                          <div className="valueText">
                            {this.state.heartRateFromSmartWatch === 0
                              ? "-"
                              : this.state.heartRateFromSmartWatch}
                            &nbsp;
                            <span className="smallValueText">
                              {this.state.heartRateFromSmartWatch !== 0
                                ? Strings("HeartRateUnit")
                                : null}
                            </span>
                          </div>
                          <div className="timestampText">
                            {this.state.heartRateTimestampFromSmartWatch === 0
                              ? ""
                              : this.state.heartRateTimestampFromSmartWatch}
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col md={6} className="dataContainer">
                      <div className="base">
                        <div className="statusImg">
                          <img
                            src={ic_dashboard_blood_pressure}
                            alt="Screen time"
                          ></img>
                        </div>
                        <div className="summery">
                          <div className="keyText">
                            {Strings("BloodPressure")}
                          </div>
                          <div className="valueText">
                            {this.state.bloodPressureFromSmartWatch === ""
                              ? "-"
                              : this.state.bloodPressureFromSmartWatch}
                            &nbsp;
                            <span className="smallValueText">
                              {this.state.bloodPressureFromSmartWatch !== ""
                                ? this.state.bloodPressureUnit
                                : null}
                            </span>
                          </div>
                          <div className="timestampText">
                            {this.state.bloodPressureTimestampFromSmartWatch ===
                            0
                              ? ""
                              : this.state.bloodPressureTimestampFromSmartWatch}
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </div>
            </div> */}


            {/*  */}
            {this.state.address && (
              <div className="locationDataContainer">
                <div className="Data_heading">Location Data</div>
                <div className="Data_subheading">
                  <div className="locationData">
                    {this.state.address} at {this.state.locationData}
                  </div>
                  <img
                    src={ic_gps}
                    alt="Screen time"
                    onClick={() => {
                      window.open(
                        "https://maps.google.com?q=" +
                          this.state.latitude +
                          "," +
                          this.state.longitude
                      );
                    }}
                  ></img>
                </div>
                <div className="ButtonContainer">
                  <div className="ViewButton">
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        window.open(
                          "https://maps.google.com?q=" +
                            this.state.latitude +
                            "," +
                            this.state.longitude
                        );
                      }}
                    >
                      <img src={ic_view} alt="ic_view" />
                      <div> {Strings("View")}</div>
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userInfo: CommonUtils.getInvitedTokenInfo(state),
    userList: state.Dashboard.userInfo,
    inviteUserInfo: state.InvitationHandler.accessInfo,
    inviteTokenInfo: state.InvitationHandler.accessInfo,
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(NewUserCard);
